import { defineComponent as _defineComponent } from 'vue'
import RmpDialog from "@rmp/core/components/dialogs/RmpDialog.vue";
import { useVuetify } from "@rmp/core/plugins/vuetify";
import { useI18n } from "vue-i18n-composable";
import RmpLink from "@rmp/core/components/common/RmpLink.vue";

export interface Props {
	value: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpDigitalSignatureInstructionsDialog',
  props: {
    value: { type: Boolean }
  },
  emits: ["update:value"],
  setup(__props: any, { emit }: { emit: ({
	(e: "update:value", value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	value: boolean;
};

const { tc } = useI18n();

const vuetify = useVuetify();





return { __sfc: true,tc, vuetify, props, emit, RmpDialog, RmpLink }
}

})